//Страница со списком рецептов

import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { fetchFilter, deleteRecipe} from '../../../store/api.js'
import { Selectdisign, SearchRecipe } from '../../molecules'
import { SideFilter, Recipe, CounterPage, Popup } from '..' 
import { filtrSearchArr } from '../../../utils/utils'
import { sorts } from '../../../constants/constants.js'
import { useRef } from 'react'; 

export function ChoiceInRecipe(props) {  
  const dispatch = useDispatch()
  const limit = 9 
  const sortRef =  useRef()
  const { lib, statusLib } = useSelector(state => state.lib)  
  const { currentUser } = useSelector(state => state.currentUser)
  const {recipes, totalCount, fetching, edge, errorPage} = useSelector(state => state.recipes) 
  const {ingredients, status} = useSelector(state => state.ingredients)  
  const [sort, setSort] = React.useState({});
  const [recipe, setRecipe] = React.useState({});
  const [category, setCategory] = React.useState([])
  const [showFilterBlock, setShowFilterBlock] = React.useState(false)
  const [kitchenware, setKitchenware] = React.useState([])
  const [type, setType] = React.useState([])
  const [statusFilter, setStatusFilter] = React.useState(false) 
  const [currentPage, setCurrentPage] = React.useState(1);
  const [choiceIngredient, setChoiceIngredient] = React.useState([]) 
  const [isOpen, setIsOpen] = React.useState(false) // Открытие сортировки 
  const [isOpenEdit, setIsOpenEdit] = React.useState(false) 
  const [showChoice, setShowChoice] = React.useState(false) // Показывает вопрос об удалении рецепта
  const allPages = Math.ceil(totalCount/limit)
  const pages = Array.from({length: allPages}, (_, i) => i + 1) 
  const [keyword, setKeyword] = React.useState('')   
  const [keywords, setKeywords] = React.useState('')
  const [hidden, sethidden] = React.useState(false)        
  const [inputTimer, setInputTimer] = React.useState(null);  
  const [calsClick, setCalsClick] = React.useState(false); 
  const [filtrMassiv, setFiltrMassiv] = React.useState([]);
  let filters = JSON.parse(localStorage.getItem('filters'));
  const [minCalories, setMinCalories] = React.useState('');
  const [maxCalories, setMaxCalories] = React.useState('');
  const [minTime, setMinTime] = React.useState('');
  const [maxTime, setMaxTime] = React.useState('');
  const [isFilterOpen, setIsFilterOpen] = React.useState(false);
  const [isAnimating, setIsAnimating] = React.useState(false);

  
  //ErrorHandler(fetching, errorPage)
  const parametrSearch = {
    currentPage,
    params: filterSearch(),
    searchWords: choiceIngredient.length === 0 ? keyword : 0,
    ingredient: parametrkeywords(),
    limit,
    sorter: sort.nameEn, 
    userId: currentUser._id ? currentUser._id : '',
    minCalories: minCalories,
    maxCalories: maxCalories,
    minTime: minTime,
    maxTime: maxTime, 
    moderator: currentUser._id ?  currentUser.supervisor : false
  };
 
  React.useEffect(() => {
    if (!filters && statusLib === 'resolved') {
      setType(lib.typeFoods)
      setCategory(lib.dish)
      setKitchenware(lib.kitchenware)
      setSort(sorts[0])
    } else if(filters !==null) {
      setType(filters.type);
      setCategory(filters.category);
      setKitchenware(filters.kitchenware) 
      setSort(sorts[0])
      setStatusFilter(filters?.statusFilter || {})
      setMinTime(filters?.minTime || edge.minTime)
      setMaxTime(filters?.maxTime || edge.maxTime)
    }
  }, [])
   
  React.useEffect(() => {  
    if (currentPage && category.length > 0 && type.length > 0 && kitchenware.length > 0) {
      dispatch(fetchFilter(parametrSearch)); 
    }
 }, [currentPage, category, type, choiceIngredient, kitchenware, sort, calsClick, statusFilter]);
  
/*React.useEffect(() => {  
  setMaxCalories(Math.round(edge.maxCalories))
  setMinCalories(Math.round(edge.minCalories))
}, [edge]); */

React.useEffect(() => {
  if (currentPage && category.length > 0 && type.length > 0) {
      clearTimeout(inputTimer);
      let timeout = setTimeout(() => { 
          parametrSearch.searchWords = keyword;
          dispatch(fetchFilter(parametrSearch));
      }, 1000);
      setInputTimer(timeout);
  }
  return () => clearTimeout(inputTimer)
}, [keyword]);

React.useEffect(() => {
  setCurrentPage(1); 
  if (type.length || category.length) {
    const filters = { type, category, kitchenware };
    filters.statusFilter = statusFilter

    if (minTime > 0) {
      filters.minTime = minTime;
    }
    
    if (maxTime > 0) {
      filters.maxTime = maxTime;
    } 
    localStorage.setItem("filters", JSON.stringify(filters));
  }
}, [category, type, kitchenware, minTime, maxTime, statusFilter]);
 
// При переключении страниц скролл наверх
React.useMemo(() => {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}, [currentPage]);

// Видимость фильтров
React.useEffect(() => {
  document.body.classList.toggle('hidden', showFilterBlock);
}, [showFilterBlock]);

function handleCounter(page) {
  setCurrentPage(page);
}

function filterSearch() {
  return type.reduce((params, s) => s.boolean ? `${params}&types[]=${s.nameEn}` : params, '') +
         category.reduce((params, s) => s.boolean ? `${params}&dishes[]=${s.nameRu}` : params, '') +
         kitchenware.reduce((params, s) => s.boolean ? `${params}&kitchenware[]=${s.nameEn}` : params, '') +
         `&owner=${statusFilter.owner}` + `&like=${statusFilter.likes}` + `&feast=${statusFilter.feast}`;
}
 
const toggleModal = () => {
  if (!isFilterOpen) {
    setIsFilterOpen(true);
  } else {
    setIsAnimating(true);
    setTimeout(() => {
      setIsFilterOpen(false);
      setIsAnimating(false);
    }, 300); // Должно совпадать с duration анимации
  }
};

function parametrkeywords() {
  let param=''
    choiceIngredient.map(i=> {
      param = param + `&keywords[]=${i._id}`
    })
  return param
}

function handleChoiceCategory(e) {
  const { name, checked } = e.target;  
  setCategory(() => category.map((c) => c.nameEn === name ? {...c, boolean: checked } : c));
  setCurrentPage(1);
}

 
const handleChoiceOwner = (value, checked) => { 
  setCurrentPage(1);
  setStatusFilter(prev => ({ 
    ...prev, 
    [value]: checked
  })); 
};


function handleChoiceType(e) {
  const { name, checked } = e.target; 
  setType((type) => type.map((c) => c.nameEn === name ? {...c, boolean: checked } : c));
  setCurrentPage(1);
}

function handleChoiceTools(e) {
  const { name, checked } = e.target; 
  setKitchenware((tools) => tools.map((c) => c.nameEn === name ? {...c, boolean: checked } : c));
  setCurrentPage(1);
}


function handleFilterBlock() {
  setShowFilterBlock(prev => !prev);
}

function handleDeleteSearch(i) {
  setChoiceIngredient(prev => prev.filter(c => c._id !== i));
}

function handleAutoText(ing) {
  setChoiceIngredient(prev => [...prev, { _id: ing._id, name: ing.name }]);
  setCurrentPage(1)
  setKeywords('');
  setKeyword('')  
  sethidden(false);
}

function handleChangeInput(e) { 
  setCurrentPage(1)
  setKeyword(e.target.value)   
  sethidden(true);
  handleFiltrClick(e.target.value) 
}

function handleReset() {
  setType(lib.typeFoods);
  setCategory(lib.dish);
  setKitchenware(lib.kitchenware)
  setChoiceIngredient([]);
  setKeyword('');
  localStorage.removeItem('filters');
  setCurrentPage(1);
  setSort(sorts[0])
}

function handleFiltrClick(keyword) {
  if (keyword) {
      setFiltrMassiv(filtrSearchArr(ingredients, keyword, 'ingredient'));
  } else {
      setFiltrMassiv([]);
      sethidden(false)
  }
}

  //Удаление рецепта
  function handleDelete() {
    dispatch(deleteRecipe(recipe._id)) 
    setShowChoice(false)
  }
 
  //Открытие модального для редактирования рецепта
  function handleEditRecipe(recipe) { 
    setIsOpenEdit(true)
    setRecipe(recipe)
  }

    //Закрытие модального для редактирования рецепта
  function handleModalClose() {
    setIsOpenEdit(false) 
    setShowChoice(false)
  } 

  //Открытие модально с запросом проверки на удаление
  function handleDeleteRecipe(recipe) { 
    setShowChoice(true)
    setRecipe(recipe)
  }

  function handlePopupModal() {
    setIsOpen(!isOpen)
  }

  function handleChangeEvents(el) { 
    setSort(el)
  } 

  const handleCalChange = (e) => {
    const { name, value } = e.target; 
    // Проверка введенных значений
    if (name === 'cals-min') {
      setMinCalories(value);
    } else if (name === 'cals-max') {
      setMaxCalories(value);
    }
  };

  const handleTimeChange = (e) => {
    const { name, value } = e.target; 
    // Проверка введенных значений
    if (name === 'time-min') {
      setMinTime(value);
    } else if (name === 'time-max') {
      setMaxTime(value);
    }
  };


  function handleCalsClick () {
    setCalsClick(!calsClick)
    setCurrentPage(1)
  }
  
  const hiddenClose= () => {
    sethidden(false)
  }
  
  return (
    <div className={`recipes show-recipes ${fetching === 'loading' ? 'loading' : ''}`} >
      <div className='filter filter__deckstop'>
        <h3 className='font26EB color filter__title filter__title_choice'>Фильтры</h3>

        {  statusLib=== 'resolved' &&
          <SideFilter 
            type={type}
            category={category}
            kitchenware={kitchenware}
            handleChoiceType={handleChoiceType}
            handleChoiceCategory={handleChoiceCategory} 
            handleChoiceTools={handleChoiceTools}
            fetching={fetching}
            name="filter" 
            handleReset={handleReset}
            value={statusFilter}
            handleChoiceOwner={handleChoiceOwner}
            handleCalChange={handleCalChange}
            handleTimeChange={handleTimeChange}
            minCalories={minCalories}
            maxCalories={maxCalories}
            minTime={minTime}
            maxTime={maxTime}
            edge={edge}
            calsClick={handleCalsClick}
          /> 
        }
      </div>
      <div className='df-c relative widt100 g50'>
      <div className='searching '>
      <div className='search search__mobile'> 
        <SearchRecipe 
          handleChangeInput={handleChangeInput}
          filtrMassiv={filtrMassiv}
          choiceIngredient={choiceIngredient}
          keywords={keywords}
          keyword={keyword}
          handleAutoText={handleAutoText} 
          handleDelete={handleDeleteSearch} 
          hidden={hidden}
          hiddenClose={hiddenClose}
        />
        
      </div>
      <div className='sort df-r g20'>
      <button 
        className='filter__mobile-button gg-filter' 
        onClick={toggleModal}
     / > 
     <button 
        className='filter__mobile-button gg-sorting' 
        onClick={handlePopupModal}
     > 
     <Popup isOpen={isOpen} ref={sortRef} type='sort'>
        {sorts.map((el, index) => (
          <p className='event-text font20Norm select-text_sorts'  key={index} onClick={()=> handleChangeEvents(el)}>{el.nameRu}</p>)
        )} 
      </Popup> 
      </button>
        <Selectdisign 
          data={sorts} 
          name={sort}
          ref={sortRef}
          title='sort'
          isOpen={isOpen}
          handleChangeEvents={handleChangeEvents}
          handlePopupModal={handlePopupModal}
        /> 
      
      </div>
      </div>
       
    <ul className='cards'>
      {recipes.length > 0 ?
      recipes.map((recipe, index) => (
        <Recipe 
          recipe={recipe} 
          key={recipe._id} 
          loggedIn={props.loggedIn}
          handleEditRecipe={handleEditRecipe} 
          handleDeleteRecipe={handleDeleteRecipe} 
          type='show'
          addRecipe={props.addRecipe} 
          replaceRecipe={props.replaceRecipe} 
          replace={props.replace} 
          closeModal={props.closeModal} 
          addExcessRecipe={props.addExcessRecipe}
          positionMenuItem={props.positionMenuItem} 
         />
      ))
      : fetching === 'resolved' && recipes.length === 0  &&
      <div className='recipe_none'>
        <p className='gg-no-dish'></p> 
         <p className=' font20Nprm '>Ничего не найдено</p> 
      </div> 
      } 
    
    </ul>
    <CounterPage handleCounter={handleCounter} pages={pages} currentPage={currentPage} totalCount={totalCount}/> 
     {/* Модальное окно */}
     {isFilterOpen && (
        <div className={`modal-overlay ${isAnimating ? 'closing' : ''}`} onClick={toggleModal}>
          <div 
            className={`modal-side ${isAnimating ? 'closing' : ''}`} 
            onClick={e => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3 className='font20EB color filter__title'>Фильтры</h3>
              <button onClick={toggleModal} className="modal-close">×</button>
            </div>
            <div className="modal-content">
            <SideFilter 
               type={type}
               category={category}
               kitchenware={kitchenware}
               handleChoiceType={handleChoiceType}
               handleChoiceCategory={handleChoiceCategory} 
               handleChoiceTools={handleChoiceTools}
               fetching={fetching}
               name="addition"
               value={statusFilter}
               handleChoiceOwner={handleChoiceOwner}
               handleReset={handleReset}
               handleCalChange={handleCalChange}
               handleTimeChange={handleTimeChange}
               minCalories={minCalories}
               maxCalories={maxCalories}
               minTime={minTime}
               maxTime={maxTime}
               edge={edge}
               calsClick={handleCalsClick}
          />
            </div>
          </div>
        </div>
      )}
      </div>
     
  </div>
  )  
}
 